module.exports = __webpack_public_path__ + "static/media/Mocha Yang.f3483c30.png";